// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, map} from 'lodash';
import classnames from 'classnames';

// App Libs
import {numberWithCommas} from '../../lib/core/string';

// Contexts
import {SearchContext} from '../../contexts/search-context';

// Styles
import './search-totals.scss';

class SearchTotals extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'search-totals': true,
            },
            className
        );
    }

    getPageLimit() {
        const {defaultPageLimit = 20, query} = this.props;

        return get(query, 'pageLimit', defaultPageLimit);
    }

    getResultText() {
        const {number, numberOfElements, size, totalElements} = this.props;
        const start = numberWithCommas(number * size + 1);
        const end = numberWithCommas(number * size + numberOfElements);
        const total = numberWithCommas(totalElements);

        return numberOfElements && size && totalElements ? `Results ${start}-${end} of ${total}` : null;
    }

    getTimeout(pageLimit) {
        let timeout = null;

        if (pageLimit >= 1000) {
            timeout = 300000;
        } else if (pageLimit >= 500) {
            timeout = 60000;
        }

        return timeout;
    }

    handleChange = (event) => {
        const {setQuery} = this.context;
        const {defaultPageLimit = 20} = this.props;
        const pageLimit = Number(get(event, 'target.value')) || defaultPageLimit;

        setQuery({
            page: 1,
            pageLimit,
            timeout: this.getTimeout(pageLimit),
        });
    };

    renderOption(limit) {
        return limit ? <option key={limit}>{limit}</option> : null;
    }

    renderPageLimit() {
        const {pageLimits = [10, 20, 50, 100, 250, 500, 1000], totalElements} = this.props;

        return totalElements && pageLimits && pageLimits.length ? (
            <span className="search-totals--page-limit">
                Show:
                <select
                    className="search-totals--page-limit-select"
                    value={this.getPageLimit()}
                    onChange={this.handleChange}
                >
                    {map(pageLimits, (limit) => this.renderOption(limit))}
                </select>
            </span>
        ) : null;
    }

    render() {
        const {noPageLimit} = this.props;

        return (
            <div className={this.getClass()}>
                <span className="search-totals--result-text">{this.getResultText()}</span>
                {!noPageLimit ? this.renderPageLimit() : null}
            </div>
        );
    }
}

SearchTotals.propTypes = {
    className: PropTypes.string,
    defaultPageLimit: PropTypes.number,
    noPageLimit: PropTypes.bool,
    number: PropTypes.number,
    numberOfElements: PropTypes.number,
    pageLimits: PropTypes.arrayOf(PropTypes.number),
    query: PropTypes.object,
    size: PropTypes.number,
    totalElements: PropTypes.number,
};

SearchTotals.contextType = SearchContext;

export default SearchTotals;
